<h1 mat-dialog-title>Retornar status pedido</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: 700px;">
    <div class="row mt-4" *ngIf="!bAutenticado">
        <div class="col-sm">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
                <mat-label>Senha master</mat-label>
                <input type="password" id="input_senha_master" matInput [(ngModel)]="senhaMaster" maxlength="50"
                    (keypress)="($event.charCode==13)?autenticarSenha():null" required>
            </mat-form-field>
        </div>

        <div class="col-auto">
            <button class="mt-4" mat-flat-button color="warn" (click)="cancelar()">
                <mat-icon>close</mat-icon> Cancelar
            </button>
        </div>
        <div class="col-auto">
            <button class="mt-4" mat-flat-button color="primary" (click)="autenticarSenha()">
                <mat-icon>check</mat-icon> Autenticar
            </button>
        </div>
    </div>

    <div *ngIf="bAutenticado">

        <div class="row mt-4 mb-4">
            <div class="col-sm">
                * Se o pagamento estiver no status "Pago" ou "Cancelado", ao retornar o status do pedido para
                "Confirmado" o valor referente ao pedido será debitado do saldo atual do cliente.
            </div>
        </div>

        <mat-divider></mat-divider>

        <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
            <button mat-flat-button color="warn" (click)="cancelar()">
                <mat-icon>clear</mat-icon> Cancelar
            </button>
            <button mat-flat-button color="primary" (click)="confirmarRetornoStatus()">
                <mat-icon>check</mat-icon> Confirmar retorno do Status para 'Confirmado'
            </button>
        </section>
    </div>
</div>